module.exports = "query GetFeaturedCards {\n  featuredCards: sendableCards(featured: true, limit: 40) {\n    ...MinimalSendableCardFragment\n  }\n}\n"